"use client";
import { createContext, useState, useContext, ReactNode } from "react";

export type User = {
    url: string;
    subscriber: string;
    user_code: string;
    codeApplication: string;
    codeModule: string;
    password: string;
    id: string;
    typeConnexion: string,
    isConnected: boolean,
    site: {
        sit_couleur: null,
        sit_id: number | null,
        sit_nom: string,
        soc_id: number | null,
        soc_nom: string,
        v_ordre: string,
    }
};

export type UserContextType = {
    user: User;
    setUser: (user: User) => void;
};
const UserContext = createContext<UserContextType | undefined>(undefined);
export const UserProvider: React.FC<{
    children?: ReactNode;
}> = ({ children }) => {
    const [user, setUser] = useState<User>({
        url: "",
        subscriber: "",
        user_code: "",
        codeApplication: "",
        codeModule: "",
        password: "",
        id: "",
        typeConnexion: "",
        isConnected: false,
        site: {
            sit_couleur: null,
            sit_id: null,
            sit_nom: "",
            soc_id: 0,
            soc_nom: "",
            v_ordre: "",
        }
    });
    return (
        <UserContext.Provider value={{ user, setUser }}>
            {children}
        </UserContext.Provider>
    );
};
export const useUser = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error("Erreur Context User");
    }
    return context;
};
